<template>
  <div class="unlock-layout layers">
    <div class="scroller" ref="scroller">
      <div class="long-content" ref="content">
        <div class="top-taller"></div>
        <!--  -->
        <div class="unlocking-title">
          {{ T('/unlock@unlocking-title') }}
        </div>

        <!-- <KeyImage class="key-image" /> -->
        <EffectFilter class="share-image-target" @upload="({ avatar, social, small }) => { prepShare({ avatar, social, small }) }" @home="$router.push('/')" />
        <!--  -->
        <div class="bottom-taller"></div>
        <!-- <div class="taller"></div>
        <div class="taller"></div> -->
      </div>
    </div>
    <!-- <FloatMenu class="float-menu" @diamond="() => { fsMenu = !fsMenu }" /> -->
    <!-- <FullMenu class="full-menu" v-show="fsMenu" @close="() => { fsMenu = false }" @lang="() => { Text.toggle() }" /> -->
  </div>
</template>

<script>
import KeyImage from '@/components/Parts/KeyImage/KeyImage.vue'
// import FloatMenu from '@/components/DOM/FloatMenu/FloatMenu.vue'
// import FullMenu from '@/components/DOM/FullMenu/FullMenu.vue'
import * as Text from '@/components/DOM/Text/Text.js'
import EffectFilter from '@/components/DOM/EffectFilter/EffectFilter.vue'

import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'
import * as Server from '@/components/DOM/Server/Server.js'

// import Instruction from './Instruction.vue'

// const play = require('audio-play')
// const load = require('audio-loader')
// let dingding = load(require('./sounds/sim-ling-ling.mp3'))

var createjs = window.createjs

createjs.Sound.alternateExtensions = ['mp3']
createjs.Sound.registerSound({src: require('./sounds/sim-ling-ling.mp3'), id: 'dingding'})

export default {
  components: {
    KeyImage,
    EffectFilter
    // FloatMenu,
    // FullMenu,
    // Instruction
  },
  data () {
    return {
      Server,
      isInView: true,
      Text,
      SC: Text.state,
      T: Text.T,
      ENG: Text.ENG,
      CHI: Text.CHI,

      fsMenu: false,
      clean () {}
    }
  },
  mounted () {
    window.dataLayer = window.dataLayer || []
    function gtag () { window.dataLayer.push(arguments) }

    gtag('event', 'conversion', {
      'allow_custom_scripts': true,
      'send_to': 'DC-6305702/mawm01/2018m01+standard'
    })

    // dingding.then(play)
    createjs.Sound.play('dingding')
    ScrollMonitor.setPercentage(0)
    this.setupScroll()
    window.addEventListener('resize', () => {
      this.setupScroll()
    })
  },
  methods: {
    async prepShare ({ avatar, social, small }) {
      Server.Store.avatarData = avatar
      Server.Store.socialData = social

      return Promise.all([
        // Promise.resolve({ shareURL: 'https://picsum.photos/200/300', status: 'ok' }),

        // enable
        this.upload({ avatar, social, small }),
        this.countDown()
      ]).then((array) => {
        let uploadResult = array[0]
        if (uploadResult) {
          console.log(uploadResult)
          Server.Store.shareLink = uploadResult.shareLink
          Server.Store.shareID = uploadResult.shareLink.replace('/api/share?code=', '')
        } else {
          console.error('share url error')
        }
        if (this.isInView) {
          this.$router.push('/share-page')
        }
      })
    },
    upload ({ avatar, social, small }) {
      return Server.sendPhoto({
        avatar: small.replace('data:image/png;base64,', ''),
        social: social.replace('data:image/png;base64,', '')
      })
    },
    countDown () {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 3 * 1000)
      })
    },
    setupScroll () {
      this.clean()
      var scroller = this.$refs['scroller']
      if (!scroller) {
        return
      }
      var content = this.$refs['content']
      var scrollerHeight = scroller.getBoundingClientRect().height
      var ccontentHeight = content.getBoundingClientRect().height
      var onScroll = () => {
        this.scrollPos = scroller.scrollTop

        ScrollMonitor.state.percentage = 0.2 * (scroller.scrollTop) / (ccontentHeight - scrollerHeight)
        // console.log(ScrollMonitor.state.percentage)
      }
      scroller.addEventListener('scroll', onScroll, false)

      this.clean = () => {
        if (scroller) {
          scroller.removeEventListener('scroll', onScroll)
        }
      }
    }
  },
  beforeDestroy () {
    this.clean()
    this.isInView = false
  }
}
</script>

<style scoped>
.unlock-layout{
  color: white;
}
.full-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.float-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.layers{
  width: 100%;
  height: 100%;
  position: relative;
  overflow:hidden;
}

.scroller{
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
}
.top-taller{
  height: 1px;
}
.taller{
  height: 75vh;
}

.bottom-taller{
  height: 1px;
}

.long-content{
  height: 100%;
}

.key-image.key{
  width: 125px;
  left: calc(50% - 125px / 2);
  top: 100px;
}

.unlocking-title{
  text-transform: uppercase;
  margin-top: 58px;
  /* Unlocking the radian: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.8px;
  text-align: center;
  line-height: 20px;
}

@media screen and (min-width: 374px) {
  .unlocking-title{
    margin-top: 78px;
  }
  .key-image.key{
    top: 140px;
  }
}

@media screen and (min-width: 413px) {
  .unlocking-title{
    margin-top: 78px;
  }
  .key-image.key{
    top: 160px;
  }
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .unlocking-title{
    margin-top: 110px;
    font-size: 28px;
  }
}

.share-image-target{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Unlock/Unlock.vue